import { Box, BoxProps } from "@chakra-ui/react";

export function SendSvg({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.5303 6.96967C17.8232 7.26256 17.8232 7.73744 17.5303 8.03033L6.53033 19.0303C6.23744 19.3232 5.76256 19.3232 5.46967 19.0303C5.17678 18.7374 5.17678 18.2626 5.46967 17.9697L16.4697 6.96967C16.7626 6.67678 17.2374 6.67678 17.5303 6.96967Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.2488 7.25117C17.1794 7.25005 17.0991 7.25002 17 7.25002H11C10.5858 7.25002 10.25 6.91423 10.25 6.50002C10.25 6.0858 10.5858 5.75002 11 5.75002H17C17.0114 5.75002 17.0229 5.75001 17.0344 5.75001C17.2396 5.74993 17.4614 5.74984 17.6486 5.77501C17.8679 5.8045 18.1481 5.88033 18.3839 6.11613C18.6197 6.35193 18.6955 6.63212 18.725 6.85145C18.7502 7.03867 18.7501 7.26046 18.75 7.46558C18.75 7.47711 18.75 7.4886 18.75 7.50002V13.5C18.75 13.9142 18.4142 14.25 18 14.25C17.5858 14.25 17.25 13.9142 17.25 13.5V7.50002C17.25 7.40094 17.25 7.32063 17.2488 7.25117Z"
          fill="white"
        />
      </svg>
    </Box>
  );
}
